"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkWL32XBDWcjs = require('./chunk-WL32XBDW.cjs');


var _chunkXKXSN756cjs = require('./chunk-XKXSN756.cjs');

// src/contracts/dex/v2_2/pool/PoolV2_2.ts
var PoolV2_2 = (_class = class extends _chunkXKXSN756cjs.BasePoolV2_2 {
  static __initStatic() {this.CPI = _chunkWL32XBDWcjs.CPIPoolV2_2}
}, _class.__initStatic(), _class);



exports.PoolV2_2 = PoolV2_2;
//# sourceMappingURL=chunk-JRI7V75B.cjs.map